
export const pl = {
  common: {
    home: 'Strona główna',
    generator: 'Generator',
    login: 'Zaloguj',
    register: 'Zarejestruj',
    logout: 'Wyloguj',
    dashboard: 'Panel',
    email: 'Email',
    password: 'Hasło',
    fullName: 'Imię i nazwisko',
    submit: 'Wyślij',
    cancel: 'Anuluj',
    close: 'Zamknij',
    save: 'Zapisz',
    delete: 'Usuń',
    edit: 'Edytuj',
    loading: 'Ładowanie...',
    error: 'Błąd',
    success: 'Sukces',
    welcome: 'Witaj',
    user: 'Użytkownik',
    subscribe: 'Subskrybuj',
    back: 'Wróć',
    sort: 'Sortuj',
    search: 'Szukaj',
    previous: 'Wstecz',
    next: 'Dalej',
    optional: 'opcjonalnie',
    yes: 'Tak',
    no: 'Nie',
    vs: 'vs',
    free: 'Darmowy',
    reset: 'Resetuj',
    updating: 'Aktualizowanie...',
    expert: 'Ekspert',
    unknown: 'Nieznany',
    roi: 'ROI',
    followers: 'obserwujących',
    follow: 'Obserwuj',
    following: 'Obserwujesz',
    unfollow: 'Przestań obserwować',
    verified: 'Zweryfikowany',
    viewProfile: 'Zobacz profil {name}',
    lastPicks: 'Ostatnie {count} typów',
    openDrawer: 'Otwórz menu',
    closeDrawer: 'Zamknij menu',
    closeModal: 'Zamknij',
    gameUnavailable: 'Mecz niedostępny',
    expertNotFound: 'Nie znaleziono eksperta',
    expertNumber: 'Ekspert #{id}',
    paginationShort: '{page} / {totalPages}',
    totalCount: '({total} łącznie)',
    odds: 'kurs',
    stake: 'Stawka',
    live: 'Na żywo',
    today: 'Dziś',
    yesterday: 'Wczoraj',
    tomorrow: 'Jutro',
    daysAgo: '{days} dni temu',
    weeksAgo: '{weeks} tyg. temu',
  },
  nav: {
    philipSnatModels: 'Predykcje',
    hub: 'Hub',
    generator: 'Generator',
    experts: 'Eksperci',
    simulator: 'Symulator',
    profile: 'Profil',
    language: 'Język',
    plans: 'Plany',
    becomeExpert: 'Zostań Ekspertem',
    expertPanel: 'Panel Eksperta',
    adminPanel: 'Panel Administratora',
    login: 'Zaloguj',
    register: 'Zarejestruj',
    logout: 'Wyloguj',
    searchExperts: 'Szukaj Ekspertów',
    following: 'Obserwowani',
    recommendations: 'Rekomendacje',
    dashboard: 'Panel',
    myParlays: 'Moje kupony',
    myProfile: 'Mój Profil',
    stats: 'Statystyki',
    settings: 'Ustawienia',
    brandAlt: 'Philip Snat',
  },
  home: {
    title1: 'Znajdź najlepsze',
    title2: 'typy na',
    textCarousel: [
      'NBA',
      'Premier League',
      'NFL',
      'Serie A',
      'MLB',
      'NHL',
      'La Liga',
      'Bundesliga',
      'Ligue 1',
      'Tennis WTA',
      'Eredivisie',
      'Ekstraklasa',
    ],
    googleSignIn: 'Zaloguj się przez Google',
    plan: {
      miniText: 'Poziom dostępu',
    },
    heroSub: 'Obserwuj ekspertów, śledź ich typy i buduj własną reputację. Przeglądaj zweryfikowanych ekspertów lub aplikuj, by dzielić się swoimi typami ze społecznością.',
    searchExperts: 'Szukaj ekspertów',
    becomeExpert: 'Zostań ekspertem',
    addRecommendation: 'Dodaj rekomendację',
    sportsArenaAlt: 'Arena sportowa',
  },
  generator: {
    title: 'Stwórz swój zakład',
    generate: 'Generuj',
    saveParlay: 'Zapisz parlay',
    setParlayName: 'Ustaw nazwę parlay',
    noEvents: 'Brak dostępnych wydarzeń w tym momencie',
    loading: 'Ładowanie wydarzeń...',
  },
  filters: {
    sport: 'Sport',
    all: 'Wszystkie',
    filters: 'Filtry',
    marketSelection: 'Wybór rynku',
    league: 'Liga',
    eventsNumber: 'Liczba wydarzeń',
    minOdds: 'Minimalne kursy',
    maxOdds: 'Maksymalne kursy',
    oddsRange: 'Kursy',
    stakeRange: 'Stawka (j)',
    rangeMinAbbrev: 'Min',
    rangeMaxAbbrev: 'Maks',
    fromDate: 'Od daty',
    toDate: 'Do daty',
    moreFilters: 'Więcej filtrów',
    clearFilters: 'Wyczyść filtry',
    selectSport: 'Wybierz sport',
    selectLeague: 'Wybierz ligę',
    loadingSports: 'Ładowanie sportów...',
    loadingLeagues: 'Ładowanie lig...',
    noLeaguesAvailable: 'Brak dostępnych lig',
    selectSportFirst: 'Najpierw wybierz sport',
    followingTipstersOnly: 'Tylko obserwowani',
    outcome: 'Wynik',
    outcomeAll: 'Wszystkie wyniki',
    outcomeWin: 'Wygrana',
    outcomeLoss: 'Przegrana',
    outcomePending: 'W toku',
    outcomeVoid: 'Anulowany',
    minStake: 'Min stawka',
    maxStake: 'Maks stawka',
  },
  expertsRecommendationsFeed: {
    title: 'Rekomendacje',
    subtitle: 'Darmowe typy od wszystkich ekspertów',
    shuffle: 'Losuj kolejność',
    prevPage: 'Wstecz',
    nextPage: 'Dalej',
    pageOf: 'Strona {page} z {totalPages}',
    empty: 'Brak typów dla wybranych filtrów.',
    loadError: 'Nie udało się załadować rekomendacji.',
    viewExpert: 'Profil eksperta',
    followingFilterAria: 'Filtr obserwowanych',
  },
  parlaySummary: {
    totalOdds: 'Całkowite kursy',
    odds: 'Kursy',
    minMax: 'Min/Max',
    firstEvent: 'Pierwsze wydarzenie',
    lastEvent: 'Ostatnie wydarzenie',
    na: 'N/A',
  },
  login: {
    title: 'Zaloguj',
    email: 'Email',
    password: 'Hasło',
    submit: 'Zaloguj',
    loginFailed: 'Logowanie nie powiodło się',
    validationError: 'Błąd walidacji',
    emailNotVerified: 'Zweryfikuj swój email przed zalogowaniem.',
    resendVerification: 'Wyślij ponownie email weryfikacyjny',
    resendSuccess: 'Email weryfikacyjny wysłany! Sprawdź skrzynkę.',
    emailVerifiedSuccess: 'Email zweryfikowany! Możesz się teraz zalogować.',
    emailVerifiedExpired: 'Link weryfikacyjny wygasł. Wyślij nowy poniżej.',
    emailVerifiedInvalid: 'Nieprawidłowy link weryfikacyjny.',
    forgotPassword: 'Zapomniałeś hasła?',
    passwordResetSuccess: 'Hasło zostało zresetowane. Możesz się teraz zalogować.',
  },
  forgotPassword: {
    title: 'Zapomniałeś hasła',
    email: 'Email',
    submit: 'Wyślij link resetujący',
    successMessage: 'Jeśli konto z tym adresem email istnieje, wysłaliśmy instrukcje resetowania.',
    backToLogin: 'Wróć do logowania',
    genericError: 'Coś poszło nie tak. Spróbuj ponownie.',
  },
  resetPassword: {
    title: 'Resetuj hasło',
    newPassword: 'Nowe hasło',
    confirmPassword: 'Potwierdź hasło',
    submit: 'Ustaw nowe hasło',
    passwordMismatch: 'Hasła nie są identyczne.',
    successRedirecting: 'Hasło zresetowane! Przekierowanie do logowania…',
    invalidToken: 'Ten link resetujący jest nieprawidłowy lub wygasł.',
    genericError: 'Coś poszło nie tak. Spróbuj ponownie.',
  },
  register: {
    title: 'Zarejestruj',
    email: 'Email',
    password: 'Hasło',
    repeatPassword: 'Powtórz hasło',
    birthdate: 'Data urodzenia',
    selectCountry: 'Wybierz kraj',
    submit: 'Utwórz konto',
    success: 'Konto utworzone! Sprawdź skrzynkę, aby zweryfikować email.',
    registrationFailed: 'Rejestracja nie powiodła się',
    validationError: 'Błąd walidacji',
    passwordMismatch: 'Hasła nie są takie same',
    stepIndicator: 'Krok {n} z 5',
    back: 'Wstecz',
    continue: 'Dalej',
    notExpertLink: 'Nie chcę być ekspertem, szukam tylko typów',
    notExpertSubline: 'Zawsze możesz zostać ekspertem później.',
    onlyLookingForPicks: 'Szukam tylko najlepszych typów!',
    previewNamePlaceholder: 'Twoja nazwa',
    identityTitle: 'Zbudujmy Twój profil',
    identitySubtitle: 'Zacznij od tego, jak widzą Cię inni.',
    nameLabel: 'Jak zobaczą Cię inni?',
    namePlaceholder: 'np. Paweł Kowalski',
    countryLabel: 'Skąd jesteś?',
    shuffle: 'Losuj awatar',
    sportsTitle: 'Jakie sporty lubisz najbardziej?',
    sportsSubtitle: 'Wybierz dwa.',
    leagueTitle: 'Jaką ligę lubisz najbardziej?',
    leagueSubtitle: 'Wybierz ulubioną.',
    descriptionTitle: 'Jak byś siebie opisał?',
    descriptionSubtitle: 'Krótki opis do Twojego profilu.',
    descriptionLabel: 'Krótki opis',
    descriptionPlaceholder: 'Opowiedz nam o swojej wiedzy, strategiach i tym, co Cię wyróżnia...',
    accountTitle: 'Utwórz konto',
    accountSubtitle: 'Ostatni krok — dane do logowania.',
  },
  becomeExpert: {
    title: 'Zostań Ekspertem',
    subtitle: 'Podziel się swoją wiedzą o zakładach i zbuduj grono obserwujących',
    description: 'Opis',
    descriptionPlaceholder: 'Opowiedz nam o swojej wiedzy, strategiach i tym, co Cię wyróżnia...',
    submit: 'Wyślij zgłoszenie',
    success: 'Gratulacje! Jesteś teraz ekspertem.',
    alreadyExpert: 'Jesteś już zarejestrowany jako ekspert.',
    error: 'Nie udało się wysłać zgłoszenia. Spróbuj ponownie.',
  },
  expertPanel: {
    title: 'Panel Eksperta',
    subtitle: 'Zarządzaj swoim profilem eksperta i rekomendacjami',
    editProfile: 'Edytuj profil eksperta',
    manageRecommendations: 'Zarządzaj rekomendacjami',
    manageMonetization: 'Zarządzaj monetyzacją',
    checkYourStory: 'Sprawdź swoją historię',
    statistics: 'Statystyki',
    setDescription: 'Ustaw opis',
    descriptionSublabel: 'To jest to, co użytkownicy zobaczą odwiedzając Twój profil.',
    descriptionPlaceholder: 'Opowiedz o swojej wiedzy, strategiach i tym, co Cię wyróżnia...',
    save: 'Zapisz zmiany',
    saving: 'Zapisywanie...',
    saveSuccess: 'Profil zaktualizowany pomyślnie!',
    saveError: 'Nie udało się zaktualizować profilu. Spróbuj ponownie.',
    avatarColor1: 'Kolor 1',
    avatarColor2: 'Kolor 2',
    avatarPickColor: 'Wybierz kolor',
  },
  manageMonetization: {
    currentPlans: 'Obecne plany',
    addNew: 'Dodaj nowy',
    noPlans: 'Brak planów. Utwórz swój pierwszy plan!',
    connect: 'Połącz konto bankowe',
    connectDescription: 'Zarabiaj na swoich typach. Połącz konto bankowe przez Stripe.',
    connecting: 'Łączenie...',
    connectPending: 'Dokończ konfigurację Stripe',
    connectPendingDesc: 'Twoje konto zostało utworzone. Kliknij, aby dokończyć konfigurację i zacząć otrzymywać płatności.',
    connectSuccess: 'Konto bankowe połączone',
    connectSuccessDesc: 'Wszystko gotowe. Użytkownicy mogą teraz kupić 30-dniowy dostęp do Twoich planów.',
  },
  manageRecommendations: {
    subtitle: 'Zarządzaj swoimi rekomendacjami zakładów',
    addRecommendations: 'Dodaj rekomendacje',
    addRecommendationTitle: 'Dodaj rekomendację',
    backToRecommendations: 'Wróć',
    currentRecommendations: 'Twoje rekomendacje',
    noRecommendations: 'Brak rekomendacji. Dodaj swoją pierwszą!',
    noDescription: 'Brak opisu',
    allTiers: 'Wszystkie poziomy',
    tierFilterLockedHint: 'Filtr poziomów jest obecnie zablokowany.',
    tierSelectLockedHint: 'Rekomendacje są dodawane dla poziomu darmowego.',
    popularGames: 'Popularne mecze',
    noPopularGames: 'Brak popularnych meczy',
    orSearch: 'Lub szukaj',
    searchTeams: 'Szukaj drużyn',
    searchPlaceholder: 'Lakers, Arsenal...',
    games: 'Mecze',
    noGamesFound: 'Nie znaleziono meczy',
    backToGames: 'Powrót do meczy',
    availableBets: 'Dostępne zakłady',
    otherTab: 'Inne',
    under: 'Poniżej',
    over: 'Powyżej',
    untitledMarketGroup: '—',
    noBetsAvailable: 'Brak dostępnych zakładów dla tego meczu',
    addRecommendation: 'Dodaj',
    tierLabel: 'Poziom',
    stakeLabel: 'Stawka',
    descriptionLabel: 'Opis',
    stakePlaceholder: 'Wprowadź stawkę (np. 1.5)',
    descriptionPlaceholder: 'Dodaj swoją analizę lub uzasadnienie...',
    noTiers: 'Brak dostępnych poziomów',
    submitError: 'Nie udało się dodać rekomendacji. Spróbuj ponownie.',
    recommendationAdded: 'Rekomendacja dodana pomyślnie!',
    addWarning: 'Ta akcja jest nieodwracalna. Po dodaniu rekomendacji nie można jej usunąć. Jeśli zależy Ci na statystykach, uważnie sprawdź swój typ przed potwierdzeniem.',
  },
  dashboard: {
    title: 'Panel',
    logout: 'Wyloguj',
    welcome: 'Witaj',
    email: 'Email',
    plan: 'Plan',
    status: 'Status',
    subscriptionStatus: 'Status subskrypcji',
    expert: 'Ekspert',
    expires: 'Wygasa',
    noActiveSubscription: 'Brak aktywnej subskrypcji. Ulepsz, aby odblokować funkcje premium!',
    proFeaturesAccess: 'Masz dostęp do funkcji Pro!',
    fullFeaturesAccess: 'Masz dostęp do wszystkich funkcji!',
    quickStats: 'Szybkie statystyki',
    totalParlays: 'Całkowite zakłady',
    winRate: 'Wskaźnik wygranych',
  },
  betEventPanel: {
    lock: 'Zablokuj wydarzenie',
    unlock: 'Odblokuj wydarzenie',
    tbd: 'Do ustalenia',
    leagueFallback: 'Liga {id}',
  },
  protectedRoute: {
    loading: 'Ładowanie...',
  },
  features: {
    proFeaturesTitle: 'Funkcje Pro',
    proFeaturesDescription: 'Ta strona jest dostępna tylko dla subskrybentów Pro (hierarchy_order >= 1)!',
    basicFeaturesTitle: 'Funkcje podstawowe',
    basicFeaturesDescription: 'Ta strona jest dostępna dla subskrybentów podstawowych i wyższych (hierarchy_order >= 0)!',
  },
  errors: {
    networkError: 'Błąd sieci. Sprawdź połączenie.',
    unauthorized: 'Nie masz uprawnień do wykonania tej akcji.',
    validationError: 'Sprawdź wprowadzone dane i spróbuj ponownie.',
    genericError: 'Coś poszło nie tak. Spróbuj ponownie.',
    failedToFetchEvents: 'Nie udało się pobrać wydarzeń',
    failedToGenerateEvents: 'Nie udało się wygenerować wydarzeń',
    loginRequiredForFilter: 'Zaloguj się lub zarejestruj, aby użyć filtru {filter}',
  },
  success: {
    loginSuccess: 'Witaj ponownie!',
    registerSuccess: 'Konto utworzone pomyślnie!',
    profileUpdated: 'Profil zaktualizowany pomyślnie!',
    parlaySaved: 'Parlay zapisany pomyślnie!',
  },
  footer: {
    rights: 'Wszelkie prawa zastrzeżone.',
    privacyPolicy: 'Polityka prywatności',
    termsOfService: 'Regulamin',
    cookiePolicy: 'Polityka cookies',
    howPayoutsWork: 'Jak działają wypłaty',
  },
  myParlays: {
    noParlays: 'Brak zapisanych parlay. Utwórz swój pierwszy parlay w Generatorze!',
    event: 'wydarzenie',
    events: 'wydarzeń',
    couponResult: {
      WON: 'Wygrana',
      LOST: 'Przegrana',
      PENDING: 'Oczekuje',
      VOID: 'Anulowane',
    },
    legResult: {
      win: 'Wygrana',
      lost: 'Przegrana',
      void: 'Anulowane',
      pending: 'Oczekuje',
    },
    deleteParlay: 'Usuń parlay',
    deleteParlayConfirm: 'Usunąć ten parlay? Tej operacji nie cofniesz.',
    deleteParlayFailed: 'Nie udało się usunąć parlay.',
  },
  philipSnatStats: {
    statsCalculatedOnModelVersion: 'Statystyki obliczone na wersji modelu z dnia: {date}',
  },
  experts: {
    searchTitle: 'Szukaj Ekspertów',
    expertFilters: 'Filtry ekspertów',
    tagPlaceholder: 'Szukaj po tagu (np. NBA)',
    sortFollowers: 'Obserwujący',
    sortAppreciation: 'Ocena',
    sortCurrentPicks: 'Aktualne typy',
  },
  expertProfile: {
    back: 'Wróć',
    winRate: 'Skuteczność',
    picks: 'Typy',
    followers: 'Obserwujący',
    fullStats: 'Pełne statystyki',
    buyAccess: 'Kup dostęp',
    currentPicks: 'Aktualne typy',
    resolved: 'Rozstrzygnięte',
    noActivePicks: 'Brak aktywnych typów w tej chwili',
    noResolvedPicks: 'Brak rozstrzygniętych typów',
    accessActiveBanner: 'Płatność zakończona — masz teraz 30-dniowy dostęp!',
    accessPendingBanner: 'Płatność otrzymana — aktywujemy Twój dostęp…',
  },
  expertStats: {
    back: 'Wróć',
    followers: '{count} obserwujących',
    filters: 'Filtry',
    sport: 'Sport',
    league: 'Liga',
    tier: 'Poziom',
    odds: 'Kursy',
    stakeMin: 'STAWKA ≥',
    totalPicks: 'Łącznie typów',
    winRate: 'Skuteczność',
    avgOdds: 'Śr. kurs',
    performance: 'Wyniki',
    picksByLeague: 'Typy wg ligi',
    picksBySport: 'Typy wg sportu',
    roiTimeline: 'Oś czasu ROI',
    picksBreakdown: 'Podział typów',
    topLeague: 'Najlepsza liga',
    mostPlayedLeague: 'Najczęstsza liga',
    roiPercent: '{roi}% ROI',
    picksCount: '{count} typów',
    picksPerWeek: 'Typy / tydzień (4T)',
    last4Weeks: 'ostatnie 4 tygodnie',
    withDescription: 'Z opisem',
    percentOfPicks: '{percent}% typów',
    lastPick: 'Ostatni typ',
    date: 'Data',
    match: 'Mecz',
    stake: 'Stawka',
    result: 'Wynik',
    loadingPicks: 'Ładowanie typów…',
    noPicksFound: 'Nie znaleziono typów',
    stakeHint: 'gdybyś stawiał 10 USD na jednostkę',
    noResolvedPicksInPeriod: 'Brak rozstrzygniętych typów w tym okresie',
    noDataForPeriod: 'Brak danych w tym okresie',
    ofPicksInLeague: 'typów jest w {label}',
    ofPicksAreSport: 'typów to {label}',
  },
  hub: {
    topExperts: 'Top eksperci',
    rankedByRoi: 'Ranking wg ROI',
    noStatsYet: 'Brak statystyk',
    lastTopPicks: 'Ostatnie top typy',
    biggestOddsWon: 'Najwyższe wygrane kursy z ostatnich {days} dni',
    noWinningPicks: 'Brak wygranych typów w tym okresie',
    last30Days: '30 dni',
    last7Days: '7 dni',
    last3Days: '3 dni',
    ever: 'Zawsze',
  },
  feed: {
    upcomingPicks: 'Nadchodzące typy',
    currentPicks: 'Aktualne typy',
    featured: 'Polecane',
    versus: 'kontra',
    home: 'gospodarze',
    away: 'goście',
    homeStrip: '1 · Gospodarze',
    drawStrip: 'X · Remis',
    awayStrip: '2 · Goście',
    viewPicks: 'Zobacz typy →',
    picksLive: '{count} typów na żywo',
    expertAnalyses: '{count} analiz ekspertów',
    picksCount: '{count} typów',
    expertsCount: '{count} ekspertów',
    picksAndExperts: '{picks} · {experts}',
  },
  gameRecs: {
    backToFeed: '← Feed ekspertów',
    recommendations: 'Rekomendacje',
    experts: 'Eksperci',
    noExpertPicks: 'Brak typów ekspertów dla tego meczu.',
    expertPicks: 'Typy ekspertów',
    loadError: 'Nie udało się załadować rekomendacji.',
  },
  registerBenefits: {
    title: 'Korzyści dla zalogowanych',
    benefit1: 'Darmowe typy od wszystkich ekspertów',
    benefit2: 'Pełny dostęp do filtrów w generatorze',
    benefit3: 'Możliwość obserwowania ekspertów',
    benefit4: 'Możliwość zostania ekspertem',
    benefit5: 'Monetyzacja swoich typów',
    benefit6: 'Zapisywanie kuponów i śledzenie statystyk',
  },
  monetization: {
    level: 'Poziom',
    name: 'Nazwa',
    nameRequired: 'Nazwa *',
    price: 'Cena',
    priceMonthly: 'Cena ($ / 30 dni)',
    description: 'Opis',
    editPlan: 'Edytuj plan',
    saveChanges: 'Zapisz zmiany',
    namePlaceholder: 'np. Basic, Pro, Elite',
    pricePlaceholder: '0.00',
    descriptionPlaceholder: 'Opisz funkcje tego planu...',
    perMonth: '${price} / 30 dni',
    access30Days: 'Dostęp na 30 dni',
    featuresList: 'Funkcje',
    addFeature: 'Dodaj funkcję',
    featurePlaceholder: 'np. Dostęp do wszystkich typów',
    featured: 'Wyróżniony plan',
    tierColor: 'Kolor planu',
  },
  expertPanelExtras: {
    tag1: 'Tag 1',
    tag2: 'Tag 2',
    tag3: 'Tag 3',
    tagPlaceholderSport: 'np. Piłka nożna',
    tagPlaceholderLeague: 'np. NBA',
    tagPlaceholderStyle: 'np. Wysokie kursy',
    accountCreatedOn: 'Konto eksperta utworzone: {date}',
    editRecommendation: 'Edytuj rekomendację',
    updateRecommendation: 'Aktualizuj rekomendację',
    updateFailed: 'Nie udało się zaktualizować rekomendacji',
  },
  matchDashboard: {
    classifiers: 'Klasyfikatory',
    classifiersCaption: 'Oczekiwane gole według modelu',
    total: 'Łącznie',
    predictedScore: 'Przewidywany wynik',
    expectedGoals: 'Oczekiwane gole',
    home: 'Gospodarz',
    away: 'Gość',
    winProbability: 'Szansa na wygraną',
    regulation: 'Czas regulaminowy',
    goals: 'Gole drużyny',
    totalGoals: 'Gole łącznie',
    distribution: 'Rozkład',
    overUnder: 'Powyżej / poniżej',
    over: 'powyżej',
    under: 'poniżej',
    win: 'wygrana',
    markets: 'Pozostałe rynki',
    allGames: 'Wszystkie mecze',
    matchResult: 'Wynik meczu',
    btts: 'Obie drużyny strzelą',
    winToNil: 'wygrana do zera',
    correctScore: 'Wynik',
    noDraw: 'bez remisu',
  },
  philipSnat: {
    modelsTitle: 'Modele Philip Snat',
    modelsSubtitle: 'Predykcje modeli uczenia maszynowego',
    hockey: 'Hokej',
    soccer: 'Piłka nożna',
    today: 'Dziś',
    gamesCount: { one: '{count} mecz', few: '{count} mecze', many: '{count} meczów', other: '{count} meczu' },
    statsButton: 'Statystyki',
    noCsvFiles: 'Brak plików CSV',
    predictionStats: 'Statystyki predykcji',
    noStatsAvailable: 'Brak statystyk',
    showAllGames: 'Pokaż wszystkie mecze',
    hideGames: 'Ukryj mecze',
    correctPicks: 'Trafione typy',
    fileIdRequired: 'Wymagany identyfikator pliku',
    noDataAvailable: 'Brak danych',
    loadCsvFailed: 'Nie udało się załadować danych CSV',
    download: 'Pobierz',
    view: 'Podgląd',
    remove: 'Usuń',
    deleteConfirm: 'Czy na pewno chcesz usunąć „{fileName}"?',
    deleteFailed: 'Nie udało się usunąć pliku. Spróbuj ponownie.',
  },
  charts: {
    postingRhythm: 'Rytm publikacji',
    less: 'mniej',
    more: 'więcej',
    pick: 'typ',
    picks: 'typów',
    heatmapTooltip: '{day} {hour}:00 — {count} {pickLabel}',
    period7d: '7D',
    period30d: '30D',
    period3m: '3M',
    periodYtd: 'YTD',
    periodAll: 'Wszystko',
    days: ['Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob', 'Niedz'],
  },
  pickResults: {
    won: 'Wygrana',
    lost: 'Przegrana',
    void: 'Anulowany',
    pending: 'Oczekuje',
    win: 'Wygrana',
  },
  tiers: {
    free: 'Darmowy',
    pro: 'Pro',
    elite: 'Elite',
    tierN: 'Poziom {level}',
  },
  pages: {
    settingsTitle: 'Ustawienia',
    settingsDescription: 'Ta strona będzie zawierać ustawienia i preferencje użytkownika.',
    plansTitle: 'Plany',
    plansDescription: 'Ta strona będzie zawierać plany subskrypcji.',
    simulatorTitle: 'Symulator',
    simulatorDescription: 'Ta strona będzie zawierać symulator portfela zakładów.',
    noStatsBecomeExpert: 'Brak statystyk. Zostań ekspertem, aby śledzić swoje wyniki.',
  },
  sports: {
    'Piłka nożna': 'Piłka nożna',
    'e-Piłka nożna': 'e-Piłka nożna',
    'Tenis': 'Tenis',
    'Koszykówka': 'Koszykówka',
    'e-Koszykówka': 'e-Koszykówka',
    'Siatkówka': 'Siatkówka',
    'Hokej na lodzie': 'Hokej na lodzie',
    'Tenis stołowy': 'Tenis stołowy',
    'Counter-Strike 2': 'Counter-Strike 2',
    'Sporty walki': 'Sporty walki',
    'Piłka ręczna': 'Piłka ręczna',
    'e-Hokej na lodzie': 'e-Hokej na lodzie',
    'Sporty zimowe': 'Sporty zimowe',
    'Skoki narciarskie': 'Skoki narciarskie',
    'Dart': 'Dart',
    'League of Legends': 'League of Legends',
    'Badminton': 'Badminton',
    'Baseball': 'Baseball',
    'Bandy': 'Bandy',
    'Biathlon': 'Biathlon',
    'Biegi narciarskie': 'Biegi narciarskie',
    'Boks': 'Boks',
    'Bowls': 'Bowls',
    'Call of Duty': 'Call of Duty',
    'Curling': 'Curling',
    'Dota 2': 'Dota 2',
    'Formuła': 'Formuła',
    'Futbol amerykański': 'Futbol amerykański',
    'Futbol australijski': 'Futbol australijski',
    'Futsal': 'Futsal',
    'Golf': 'Golf',
    'Hokej na rolkach': 'Hokej na rolkach',
    'Hokej na trawie': 'Hokej na trawie',
    'Honor of Kings': 'Honor of Kings',
    'Kolarstwo': 'Kolarstwo',
    'Koszykówka 3x3': 'Koszykówka 3x3',
    'Krykiet': 'Krykiet',
    'Lacrosse': 'Lacrosse',
    'Narciarstwo alpejskie': 'Narciarstwo alpejskie',
    'Rainbow Six': 'Rainbow Six',
    'Piłka wodna': 'Piłka wodna',
    'Rozrywka i polityka': 'Rozrywka i polityka',
    'Rugby': 'Rugby',
    'Siatkówka plażowa': 'Siatkówka plażowa',
    'Snooker': 'Snooker',
    'Sporty motorowe': 'Sporty motorowe',
    'Squash': 'Squash',
    'Unihokej': 'Unihokej',
    'Valorant': 'Valorant',
    'e-Tenis': 'e-Tenis',
    'Żużel': 'Żużel',
  } as Record<string, string>,
  admin: {
    users: 'Użytkownicy',
    sportIcons: 'Ikony Sportów',
    leagues: 'Ligi',
    id: 'ID',
    email: 'Email',
    fullName: 'Imię i nazwisko',
    country: 'Kraj',
    admin: 'Admin',
    active: 'Aktywny',
    created: 'Utworzono',
    league: 'Liga',
    sport: 'Sport',
    download: 'Pobieranie',
    downloading: 'Pobierane',
    notDownloading: 'Niepobierane',
    philipSnatRunners: 'Uruchamianie prognoz',
    runnerMidnight: 'Prognozy o północy (00:00 UTC)',
    runnerNoon: 'Prognozy w południe (12:00 UTC)',
    runnerLeagues: 'Ligi:',
    runnerNoLeagues: 'Brak włączonych lig',
    runNow: 'Uruchom teraz',
    runnerStarting: 'Uruchamianie…',
    runnerStarted: 'Uruchomiono na Railway. Prognozy pojawią się za kilka minut.',
    runnerFailed: 'Nie udało się uruchomić.',
    runnerNotConfigured: 'Brak tokena Railway API w backendzie — ręczne uruchamianie jest wyłączone.',
  },
  myParlaysExtras: {
    noEventsFound: 'Nie znaleziono wydarzeń.',
  },
  legal: {
    lastUpdated: 'Ostatnia aktualizacja: {date}',
    terms: {
      title: 'Regulamin',
      s1Title: '1. O platformie',
      s1Text: 'Philip Snat to marketplace typów sportowych łączący ekspertów od zakładów („tipsterów") z użytkownikami zainteresowanymi przeglądaniem ich typów. Tworząc konto lub korzystając z platformy, akceptujesz niniejszy Regulamin.',
      s1Notice: 'Informacja o transparentności:',
      s1NoticeText: 'Płatne subskrypcje tipsterów nie są jeszcze dostępne. Platforma jest obecnie we wczesnym dostępie. Regulamin zostanie zaktualizowany przed uruchomieniem funkcji monetyzacji.',
      s2Title: '2. Wyłącznie w celach informacyjnych',
      s2Text1: 'Wszystkie typy, prognozy i rekomendacje na Philip Snat mają wyłącznie charakter informacyjny i rozrywkowy. Nie stanowią porady finansowej, inwestycyjnej ani bukmacherskiej.',
      s2Text2: 'Samodzielnie oceniaj typy przed podjęciem decyzji. Nigdy nie stawiaj więcej, niż możesz stracić.',
      s3Title: '3. Brak odpowiedzialności za straty',
      s3Text: 'Philip Snat i jego operatorzy nie ponoszą odpowiedzialności za straty finansowe, straty z zakładów ani inne szkody wynikające z korzystania z typów tipsterów na platformie. Korzystasz z platformy wyłącznie na własne ryzyko.',
      s4Title: '4. Wymóg wieku',
      s4Text: 'Musisz mieć co najmniej 18 lat, aby korzystać z Philip Snat. Ze względu na charakter treści związanych z hazardem dostęp dla osób poniżej 18 lat jest surowo zabroniony. Rejestrując się, potwierdzasz, że masz ukończone 18 lat.',
      s5Title: '5. Zasady konta',
      s5Intro: 'Tworząc konto, zobowiązujesz się do:',
      s5Item1: 'Podawania prawdziwych i rzetelnych danych rejestracyjnych',
      s5Item2: 'Zachowania poufności danych logowania i niedzielenia się nimi',
      s5Item3: 'Niezakładania wielu kont w celu obejścia ograniczeń',
      s5Item4: 'Nieużywania platformy do spamu, oszustw ani działań niezgodnych z prawem',
      s5Item5: 'Niepublikowania wprowadzających w błąd, sfałszowanych typów lub wyników',
      s6Title: '6. Zawieszenie i ban konta',
      s6Text: 'Zastrzegamy sobie prawo do zawieszenia lub trwałego zablokowania kont naruszających Regulamin, w tym m.in. za podawanie fałszywych informacji, nadużywanie platformy, działalność oszukańczą lub naruszenie prawa. W poważnych przypadkach możemy działać bez wcześniejszego powiadomienia.',
      s7Title: '7. Własność intelektualna',
      s7Text: 'Cała zawartość platformy, design i oprogramowanie należą do Philip Snat. Typy publikowane przez tipsterów pozostają ich własnością intelektualną. Nie wolno reprodukować, dystrybuować ani odsprzedawać treści platformy bez pisemnej zgody.',
      s8Title: '8. Zmiany regulaminu',
      s8Text: 'Możemy aktualizować Regulamin w miarę rozwoju platformy — zwłaszcza przy wprowadzaniu monetyzacji. O istotnych zmianach poinformujemy zarejestrowanych użytkowników. Dalsze korzystanie po opublikowaniu zmian oznacza ich akceptację.',
      s9Title: '9. Prawo właściwe',
      s9Text: 'Regulamin podlega prawu polskiemu. Spory wynikające z korzystania z platformy podlegają wyłącznej jurysdykcji sądów polskich.',
    },
    privacy: {
      title: 'Polityka prywatności',
      s1Title: '1. Wprowadzenie',
      s1Text: 'Niniejsza Polityka prywatności wyjaśnia, w jaki sposób Philip Snat („my") zbiera, wykorzystuje i chroni dane osobowe użytkowników („Ty") korzystających z platformy. Chronimy Twoją prywatność zgodnie z RODO oraz obowiązującym prawem polskim i unijnym.',
      s2Title: '2. Jakie dane zbieramy',
      s2Intro: 'Podczas rejestracji zbieramy następujące dane osobowe:',
      s2Email: 'Adres email — do utworzenia konta i wysyłki emaili weryfikacyjnych',
      s2FullName: 'Imię i nazwisko — do identyfikacji konta na platformie',
      s2Birthdate: 'Data urodzenia — weryfikacja minimalnego wieku (18+)',
      s2Country: 'Kraj — cele zgodności regionalnej',
      s2Outro: 'Nie zbieramy wrażliwych danych osobowych poza wymienionymi powyżej.',
      s3Title: '3. Weryfikacja email',
      s3Text: 'Po rejestracji wysyłamy email potwierdzający z linkiem ważnym przez 24 godziny. Jeśli link wygaśnie, możesz poprosić o nowy na stronie logowania. Proces ten potwierdza własność adresu email i zapobiega nieautoryzowanej rejestracji.',
      s4Title: '4. Dane płatności',
      s4Text: 'Obecnie nie zbieramy, nie przetwarzamy ani nie przechowujemy danych płatności. Platforma nie ma aktywnych funkcji płatnych. W razie wprowadzenia płatności zaktualizujemy politykę i poinformujemy Cię przed zbieraniem danych płatniczych.',
      s5Title: '5. Twoje prawa RODO',
      s5Intro: 'Na mocy RODO masz następujące prawa dotyczące danych osobowych:',
      s5Access: 'Prawo dostępu — możesz poprosić o kopię wszystkich przechowywanych danych',
      s5Erasure: 'Prawo do usunięcia — możesz poprosić o usunięcie konta i powiązanych danych',
      s5Portability: 'Prawo do przenoszenia danych — możesz poprosić o eksport danych w formacie maszynowym',
      s5Rectification: 'Prawo do sprostowania — możesz poprosić o poprawienie nieprawidłowych danych',
      s5Object: 'Prawo sprzeciwu — możesz sprzeciwić się przetwarzaniu danych',
      s5Outro: 'Aby skorzystać z tych praw, skontaktuj się z nami poniżej. Odpowiemy w ciągu 30 dni zgodnie z RODO.',
      s6Title: '6. Kontakt w sprawach danych',
      s6Text: 'W sprawach dostępu, usunięcia i eksportu danych skontaktuj się z nami:',
      s7Title: '7. Przechowywanie danych',
      s7Text: 'Przechowujemy dane tak długo, jak konto jest aktywne. Po prośbie o usunięcie konta usuniemy dane w ciągu 30 dni, chyba że prawo wymaga dłuższego przechowywania.',
      s8Title: '8. Brak udostępniania stronom trzecim',
      s8Text: 'Nie sprzedajemy, nie wymieniamy ani nie udostępniamy danych osobowych stronom trzecim w celach komercyjnych. Dane służą wyłącznie do działania platformy Philip Snat i komunikacji w sprawie konta.',
      s9Title: '9. Podstawa prawna przetwarzania',
      s9Text: 'Przetwarzamy dane na podstawie wykonania umowy (art. 6 ust. 1 lit. b RODO) — niezbędne do świadczenia usługi — oraz prawnie uzasadnionego interesu (art. 6 ust. 1 lit. f RODO) w prowadzeniu i ulepszaniu platformy.',
      s10Title: '10. Prawo właściwe',
      s10Text: 'Polityka prywatności podlega prawu polskiemu i przepisom UE o ochronie danych, w szczególności RODO.',
    },
    cookies: {
      title: 'Polityka cookies',
      s1Title: '1. Czym są pliki cookie?',
      s1Text: 'Pliki cookie to małe pliki tekstowe zapisywane w przeglądarce podczas odwiedzania strony. Służą do prawidłowego działania witryn i zapamiętywania preferencji między wizytami.',
      s2Title: '2. Jakich cookies używamy',
      s2Intro: 'Obecnie używamy wyłącznie niezbędnych plików cookie. Są konieczne do podstawowego działania platformy i nie można ich wyłączyć bez utraty funkcjonalności.',
      tableCookie: 'Cookie',
      tablePurpose: 'Cel',
      tableDuration: 'Czas trwania',
      authPurpose: 'Utrzymuje Cię zalogowanym',
      authDuration: 'Sesja / do wylogowania',
      emailVerifyPurpose: 'Używany podczas weryfikacji email przy rejestracji',
      emailVerifyDuration: '24 godziny',
      languagePurpose: 'Zapamiętuje preferowany język interfejsu (localStorage)',
      languageDuration: 'Trwały',
      s3Title: '3. Brak analityki i cookies stron trzecich',
      s3Text: 'Obecnie nie używamy cookies analitycznych (np. Google Analytics), reklamowych, śledzących ani cookies stron trzecich. Nie zbieramy danych o zachowaniu w celach marketingowych ani profilowania.',
      s4Title: '4. Jak wyczyścić cookies',
      s4Intro: 'Możesz wyczyścić lub zablokować cookies w ustawieniach przeglądarki. Usunięcie cookies uwierzytelniających wyloguje Cię z konta. Instrukcje dla popularnych przeglądarek:',
      s4Chrome: 'Chrome: Ustawienia → Prywatność i bezpieczeństwo → Wyczyść dane przeglądania → Pliki cookie',
      s4Firefox: 'Firefox: Ustawienia → Prywatność i bezpieczeństwo → Ciasteczka i dane stron → Wyczyść dane',
      s4Safari: 'Safari: Ustawienia → Prywatność → Zarządzaj danymi witryn → Usuń wszystko',
      s4Edge: 'Edge: Ustawienia → Prywatność, wyszukiwanie i usługi → Wyczyść dane przeglądania → Pliki cookie',
      s5Title: '5. Przyszłe zmiany',
      s5Text: 'Jeśli wprowadzimy cookies nieniezbędne — np. analityczne lub reklamowe — zaktualizujemy tę politykę i uzyskamy Twoją zgodę przed ich umieszczeniem.',
    },
  },
};
